export default __webpack_public_path__ + "static/media/members-icon-selected.a5afc223.svg";